import { render, staticRenderFns } from "./BankItem.vue?vue&type=template&id=9222ad68&scoped=true&"
import script from "./BankItem.vue?vue&type=script&lang=js&"
export * from "./BankItem.vue?vue&type=script&lang=js&"
import style0 from "./BankItem.vue?vue&type=style&index=0&id=9222ad68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9222ad68",
  null
  
)

export default component.exports